export const ADD_ERROR = 'ADD_ERROR';
export const REMOVE_ERRORS = 'REMOVE_ERRORS';
export const REMOVE_ERROR = 'REMOVE_ERROR';
export const SHOW_SPINNER = 'SHOW_SPINNER';
export const REMOVE_SPINNER = 'REMOVE_SPINNER';
export const CHANGE_VIEW_STATE = 'CHANGE_VIEW_STATE';
